import React from "react";
import Icon from "@amzn/meridian/icon";
import "./ThemedTag.scss";

export type ThemedTagType = "success" | "error" | "neutral" | "gray" | "override" | "fixCompliant" | "fixLater";

export interface ThemedTagProps {
    text: string;
    type: ThemedTagType;
    iconTokens?: object;
    icon?: React.ReactNode;
}

const ThemedTag: React.FC<ThemedTagProps> = ({ text, type, iconTokens, icon }) => {
    return (
        <div className={`themed-tag themed-tag--${type}`}>
            {icon}
            {iconTokens && <Icon tokens={iconTokens} color="inverted" />}
            <span className={`themed-tag__text themed-tag__text--${type}`}>{text}</span>
        </div>
    );
};

export default ThemedTag;
